import type { AppMessage } from '../../tools/types';
import styles from './MessageList.module.scss';

interface Props {
  messages: AppMessage[],
  uniqueNames: number
}

const ICONS: Record<AppMessage['type'], string> = {
  error:   '⚠',
  warning: '⚡',
  success: '✓',
};

export default function MessageList({ messages, uniqueNames }: Props) {
  if (messages.length === 0) return null;
  return (
    <ul className={styles.list} role="status" aria-live="polite">
      {messages.map((m, i) => (
        <li key={i} className={`${styles.item} ${styles[m.type]}`}>
          <span className={styles.icon} aria-hidden="true">{ICONS[m.type]}</span>
          <span>{m.text}<br />{m.text.indexOf("Loaded") > -1 && Number.isFinite(uniqueNames) ? `Identified ${uniqueNames} unique names.` : null}</span>
        </li>
      ))}
    </ul>
  );
}
